import { request } from "../client";

import type {
  LimitStatus,
  LimitCheckResponse,
  RecordShadowingSessionRequest,
  AllLimitsResponse,
  RecordShadowingSessionResponse,
} from "../types/limits";
import type { AiBudgetStatus, AiAnalyticsEvent } from "@lingoshade/domain";

export function createLimitsEndpoints(baseUrl: string): {
  getAiBudget: (
    token?: string | null,
    language?: string,
  ) => Promise<AiBudgetStatus>;
  recordAiEvent: (
    event: AiAnalyticsEvent,
    token?: string | null,
  ) => Promise<void>;
  getShadowingDailyLimit: (
    token?: string | null,
    textId?: string,
  ) => Promise<LimitStatus>;
  checkShadowingLimit: (token?: string | null) => Promise<LimitCheckResponse>;
  recordShadowingSession: (
    payload: RecordShadowingSessionRequest,
    token?: string | null,
  ) => Promise<RecordShadowingSessionResponse>;
  getAllLimits: (token?: string | null) => Promise<AllLimitsResponse>;
} {
  return {
    getAiBudget(
      token?: string | null,
      language?: string,
    ): Promise<AiBudgetStatus> {
      return request<AiBudgetStatus>(baseUrl, "/ai-budget/status", {
        token,
        query: { language },
      });
    },
    recordAiEvent(
      event: AiAnalyticsEvent,
      token?: string | null,
    ): Promise<void> {
      return request<void>(baseUrl, "/ai-budget/events", {
        method: "POST",
        body: event,
        token,
      });
    },
    /**
     * Get current shadowing daily limit status
     */
    getShadowingDailyLimit(
      token?: string | null,
      textId?: string,
    ): Promise<LimitStatus> {
      return request<LimitStatus>(baseUrl, "/limits/shadowing-daily", {
        method: "GET",
        token,
        query: { textId },
      });
    },

    /**
     * Check if shadowing session is allowed
     */
    checkShadowingLimit(token?: string | null): Promise<LimitCheckResponse> {
      return request<LimitCheckResponse>(
        baseUrl,
        "/limits/shadowing-daily/check",
        {
          method: "POST",
          token,
        },
      );
    },

    /**
     * Record shadowing session usage
     */
    recordShadowingSession(
      payload: RecordShadowingSessionRequest,
      token?: string | null,
    ): Promise<RecordShadowingSessionResponse> {
      return request<RecordShadowingSessionResponse>(
        baseUrl,
        "/limits/shadowing-daily/record",
        {
          method: "POST",
          body: payload,
          token,
        },
      );
    },

    /**
     * Get all user limits
     */
    getAllLimits(token?: string | null): Promise<AllLimitsResponse> {
      return request<AllLimitsResponse>(baseUrl, "/limits/all", {
        method: "GET",
        token,
      });
    },
  };
}
